import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import LiveMobileView from "components/LiveMobileView";
import useLiveDashboardSession from "hooks/useLiveDashboardSession";
import LiveDashboardGate from "./LiveDashboardGate";

const PrizeLeaderboardLiveMobile = () => {
  const { productId, playToken: playTokenParam } = useParams();
  const playToken = decodeURIComponent(playTokenParam || "");
  const navigate = useNavigate();
  const session = useLiveDashboardSession(productId, playToken);

  if (session.gate !== "ready") {
    return (
      <LiveDashboardGate
        gate={session.gate}
        goBack={session.goBack}
        navigate={navigate}
      />
    );
  }

  return (
    <LiveMobileView
      product={session.selectedProduct}
      selectedWish={session.selectedWish}
      history={session.history}
      uniqueUserCount={session.uniqueUserCount}
      historyLoading={session.historyLoading}
      onClose={session.goBack}
      onRefresh={session.handleRefreshLiveData}
      refreshing={session.liveRefreshing}
      refreshTrigger={session.liveRefreshTick}
      realtimeConnected={session.liveRealtimeConnected}
      dashboardStats={session.dashboardStats}
      dashboardStatsLoading={session.dashboardStatsLoading}
      onRefreshDashboardStats={session.refetchDashboardStats}
      dashboardStatsRefreshing={session.dashboardStatsFetching}
      productActive={session.productActive}
      onToggleProductActive={session.handleToggleProductActive}
      togglingProductStatus={session.togglingProductStatus}
      productPlayable={session.productPlayable}
      onToggleProductPlayable={session.handleToggleProductPlayable}
      togglingPlayableStatus={session.togglingPlayableStatus}
      onConfirmAnnounceResult={session.handleConfirmAnnounce}
      announcingResult={session.announcingResult}
      canAnnounceResult
    />
  );
};

export default PrizeLeaderboardLiveMobile;
